import { TenantEntity } from '../TenantEntity'

export class Project extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get projectId() {
    return this._data.projectId
  }
  set projectId(projectId) {
    this._data.projectId = projectId || 0
  }
  get projectName() {
    return this._data.projectName
  }
  set projectName(projectName) {
    this._data.projectName = projectName
  }
  get projectStatus() {
    return this._data.projectStatus
  }
  set projectStatus(projectStatus) {
    this._data.projectStatus = projectStatus || 0
  }
  get partener() {
    return this._data.partener
  }
  set partener(partener) {
    this._data.partener = partener
  }
  get dateStart() {
    return this._data.dateStart
  }
  set dateStart(dateStart) {
    this._data.dateStart = dateStart
  }
  get dateEnd() {
    return this._data.dateEnd
  }
  set dateEnd(dateEnd) {
    this._data.dateEnd = dateEnd
  }
  get settleCurrency() {
    return this._data.settleCurrency
  }
  set settleCurrency(settleCurrency) {
    this._data.settleCurrency = settleCurrency || 0
  }
  get expectIncome() {
    return this._data.expectIncome
  }
  set expectIncome(expectIncome) {
    this._data.expectIncome = expectIncome
  }
  get expectCost() {
    return this._data.expectCost
  }
  set expectCost(expectCost) {
    this._data.expectCost = expectCost || 0
  }
  get expectExpense() {
    return this._data.expectExpense
  }
  set expectExpense(expectExpense) {
    this._data.expectExpense = expectExpense || 0
  }
  get expectProfitTate() {
    return this._data.expectProfitTate
  }
  set expectProfitTate(expectProfitTate) {
    this._data.expectProfitTate = expectProfitTate || 0
  }
  get realIncome() {
    return this._data.realIncome
  }
  set realIncome(realIncome) {
    this._data.realIncome = realIncome || 0
  }
  get realCost() {
    return this._data.realCost
  }
  set realCost(realCost) {
    this._data.realCost = realCost || 0
  }
  get realExpense() {
    return this._data.realExpense
  }
  set realExpense(realExpense) {
    this._data.realExpense = realExpense || 0
  }
  get realProfitTate() {
    return this._data.realProfitTate
  }
  set realProfitTate(realProfitTate) {
    this._data.realProfitTate = realProfitTate || 0
  }
  get projectManager() {
    return this._data.projectManager
  }
  set projectManager(projectManager) {
    this._data.projectManager = projectManager
  }
  get projectDepartment() {
    return this._data.projectDepartment
  }
  set projectDepartment(projectDepartment) {
    this._data.projectDepartment = projectDepartment
  }
  get projectOffice() {
    return this._data.projectOffice
  }
  set projectOffice(projectOffice) {
    this._data.projectOffice = projectOffice
  }
  get receiveStatus() {
    return this._data.receiveStatus
  }
  set receiveStatus(receiveStatus) {
    this._data.receiveStatus = receiveStatus || 0
  }
  get payStatus() {
    return this._data.payStatus
  }
  set payStatus(payStatus) {
    this._data.payStatus = payStatus || 0
  }
  get remarks() {
    return this._data.remarks
  }
  set remarks(remarks) {
    this._data.remarks = remarks
  }
  /**
   * 获取不到父类中的属性名称，所以各个子类都要实现该方法（与父类中的结果合并）
   */
  getPropertyNames() {
    const parentNames = super.getPropertyNames()
    const obj = new Project(this._data)
    let names = Object.getOwnPropertyNames(Reflect.getPrototypeOf(obj))
    names = names.filter(p => typeof obj[p] !== 'function')
    return [...parentNames, ...names]
  }
}
